<template>
    <div class="dashboard-container">
       <adminDashboard/>
    </div>
</template>

<script>
    import adminDashboard from './admin'
    import { gateway } from '@/api/admin.js'
    export default {
        name: 'Dashboard',
        components: {adminDashboard},
        data() {
            return {
                currentRole: ''
            }
        },
        computed: {
        },
        created() {
           // this.getRole()
        },
        methods: {
          // getRole(){
          //   this.loading=true;
          //
          //   let str = JSON.stringify({
          //     role_id: 0,
          //   });
          //   gateway({
          //     func: 'get_agency_role',
          //     page_no:1,
          //     page_size:10,
          //     params:str
          //   }).then(res => {
          //     this.loading=false;
          //     this.tableData= res.result;
          //   })
          // },
        }
    }
</script>
